import * as React from 'react';
import { Grid, withStyles, StyledComponentProps, Divider, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { styles } from './styles';
import { forcedAccess, passage } from '../../../../model/access';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';
import { Select } from '../../../../ui-components/select/Select';
import { room } from '../../../../model/room';


interface IProps extends StyledComponentProps {
    onCancel: () => any;
    onSave: (result: forcedAccess) => any;
    open: boolean;
    sub: string;
    passage: passage;
    roomList: Array<room>;
}
interface IState {
    _id: string;
    ip: string;
    nome: string;
}

// const callAccess = (ip: string, sub: string): void => {
export function callAccess(ip: string, api: string, method: string, request: {}) {
    // console.info(ip);
    // console.info(sub);
    // const requestOptions = {
    //     method: method,
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(request)
    // };
    // var uri = 'https://' + ip + ':4443' + api;
    // return await fetch(uri, requestOptions)
    //     .then(async response => {
    //         const data = await response.json();
    //         // check for error response
    //         if (!response.ok) {
    //             // get error message from body or default to response statusText
    //             const error = (data && data.message) || response.statusText;
    //             return Promise.reject(error);
    //         }
    //         return data;
    //         // this.setState({ totalReactPackages: data.total })
    //     })
    //     .catch(error => {
    //         // this.setState({ errorMessage: error.toString() });
    //         console.error('There was an error!', error);
    //         return null;
    //     });
    var uri = 'http://' + ip + ':4443/rpi';
    console.info("uri", uri)
    console.info("api", api)
    // window.open('http://192.168.1.104:4443/test', 'servicePage', 'width=320,height=320')
    // const uri = 'http://192.168.1.104:4443/test'
    const wind = window.open(uri, 'servicePage', "width=320,height=320");
    setTimeout(() => {
        wind?.postMessage({ type: 'command', api: api, method: method, request: request }, uri);
    }, 2 * 1000);
    return wind;
}

class AccessDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = { _id: undefined, ip: undefined, nome: undefined }
    }

    wind: Window | null;

    componentDidMount(): void {
        window.addEventListener('message', this.getEvent);
    }

    componentWillUnmount(): void {
        window.removeEventListener('message', this.getEvent);
    }

    getEvent = (event) => {
        // window.opener.postMessage({ type: "command", response: y }, "http://localhost:49379");
        if (event && event.data && event.data.type === 'command') {
            // debugger;
            console.log("event", event.data)
            if (event.data.response !== undefined) {
                var _accessAllowed = (event.data.response.status === "OK");
                var _message = event.data.response.message;
                var _ip = this.state.ip;
                var _roomId = this.state._id;
                var _userId = this.props.sub;
                console.info(event);
                var forcedAccess: forcedAccess = {
                    accessAllowed: _accessAllowed,
                    ip: _ip,
                    roomId: _roomId,
                    result: _message,
                    userId: _userId
                };
                this.props.onSave(forcedAccess);
            }
            if (this.wind) {
                this.wind.close();
            }
        }
    }

    saveAccess = () => {
        console.info("sub", this.props.sub);
        console.info("ROOM ID : ", this.state._id);
        // console.info(this.state.ip);
        console.info("this.state.nome", this.state.nome);
        if (this.state.ip !== undefined && this.state.ip !== "0.0.0.0") {
            var body = { sub: this.props.sub };
            console.info("saveAccess", this.state.ip)
            // var x = {};
            // , ip: this.state.ip, roomid: this.state._id
            // callAccess(this.state.ip, '/open', 'POST', x).then(
            //     result => {
            //         console.info("OPEN!!!!!!!!!!!!!!!!!!!!")
            //         console.log(result);
            //     }
            // );
            this.wind = callAccess(this.state.ip, '/access', 'POST', body);
            // .then(
            //     result => {
            //         var _accessAllowed = false;
            //         var _message = "";
            //         if (result !== null) {
            //             console.info("RESULT!!!!!!!!!!!!!!!!!!!!")
            //             console.log(result);
            //             // message: "Welcome auth0|5e1df85a0c129f0e9da1ce1d! Tue 05-01-2021 00:52:40"
            //             // status: "OK"
            //             _accessAllowed = (result.status === "OK");
            //             _message = result.message;
            //         }
            //     }
            // );
        }
    }
    setVarco = (item: any) => {
        // console.info(item)
        // var ip = "0.0.0.0";
        // if (item && item.ip) {
        //     ip = item.ip;
        // }
        this.setState({ ip: item.ip, nome: item.name, _id: item.value });
    }

    render() {
        var title = "Nuovo Accesso";
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
                <DialogContent>
                    <Grid container style={{ alignItems: "center" }}>
                        <Grid item xs={12}>
                            <Typography>User</Typography>
                            <Typography>{this.props.sub}</Typography>
                            <Typography>Passage</Typography>
                            <Typography>{this.props.passage}</Typography>
                            <Typography>Varco</Typography>
                            <Select fullWidth
                                selected={this.state._id ? { name: this.state.nome, value: this.state._id } : { name: '', value: '' }}
                                items={this.props.roomList.map(t => { return { name: t.description, value: t._id, ip: t.ipAddress } })}
                                onChange={(item) => this.setVarco(item)}
                                label='Seleziona un Accesso' />
                        </Grid>
                    </Grid>
                    <Divider style={{ width: "100%" }} />
                </DialogContent >
                <DialogActions>
                    <SaveIconButton onClick={this.saveAccess} />
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

export default (withStyles(styles)(AccessDialog));
